export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-17.jpg'),
        title: 'IoT（モノのインターネット）',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: '情報技術革命の新しい波',
      description: `<p style="font-size: 1.8rem;">
      IoT（モノのインターネット）は、インターネットに続く次の情報技術革命の波と見なされています。IoTがもたらす産業的価値はインターネットのそれを上回る可能性があり、次の大規模な情報産業ビジネスとなるでしょう。
    </p><p>
    IoTはもはや単なるトレンドではなく現実です。インターネットの長年の発展とスマートデバイスの普及が基盤を築き、端末のネットワーク化とインテリジェント化によりIoTは急速に普及しています。今後さらに成長が見込まれます。<br/>
    当社のサービス：<br/>
    設計：豊富な経験を持つデザインチームが顧客の要件に合わせた製品設計を行います。ハードウェア選定からファームウェア、OS、ミドルウェア、アプリ開発に至るフルスタックのIoTソリューションを提供します。<br/>
    開発：高い技術力を持つチームが製品の研究開発を行い、360度QAテスト、自動化、ハードウェアプロトタイプ作成、一貫性テストを提供します。専門的な開発により顧客の信頼を得ます。<br/>
    アフターサービス：フルサービスの技術提供者として、ソフトウェア・ハードウェアの更新により製品のバージョンアップを支援し、顧客が競争で優位に立てるようサポートします。
    </p>`
    },
    {
      title: '当社の強み',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-17.jpg')+`)"></span>
      <span class="list">
      <i></i>強力な技術研究開発チーム<br/>
      <i></i>豊富なIT研究開発経験<br/>
      <i></i>大量データの運用・追跡・分析とそれに基づくソリューション提供プラットフォーム<br/>
      <i></i>優れたソフトウェア開発力と一流のユーザー体験<br/>
      <i></i>業界運用に精通したマネジメントチーム<br/>
      <i></i>導入事例：<br/>
      <i></i>スマートライフ<br/>
      <i></i>スマートシティ<br/>
      <i></i>スマート製造

      </span>`
    }
  ]
}
